import { Component, Optional, Inject, OnInit } from '@angular/core';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import {
  FilterService,
  SentimentFilterPolarity,
} from 'app/modules/collection/services/filter.service';
import { Widget } from 'app/providers/bridge-api/dashboard.service';
import {
  injectComponentTelemetryService,
  EnableComponentTelemetry,
  EnableClassTelemetry,
} from 'app/services/otel.service';

export interface WidgetSentimentFilterDialogOptions {
  widget: Widget;
}

@EnableClassTelemetry()
@Component({
  selector: 'app-widget-sentiment-filter',
  templateUrl: './widget-sentiment-filter.component.html',
  styleUrls: ['./widget-sentiment-filter.component.scss'],
  standalone: false,
})
export class WidgetSentimentFilterDialogComponent implements OnInit {
  @EnableComponentTelemetry() otelService = injectComponentTelemetryService();
  sentimentFilterPolarities: SentimentFilterPolarity[] = [];

  constructor(
    private dialogRef: MatDialogRef<WidgetSentimentFilterDialogOptions>,
    @Optional() @Inject(MAT_DIALOG_DATA) options: WidgetSentimentFilterDialogOptions
  ) {
    this.dialogRef.disableClose = true;
    this.sentimentFilterPolarities = FilterService.createSentimentFilterPolarities(options.widget);
  }

  ngOnInit() {}

  get isSaveDisabled(): boolean {
    for (const polarity of this.sentimentFilterPolarities) {
      if (polarity.checked) {
        return false;
      }
    }
    return true;
  }

  cancel() {
    this.dialogRef.close();
  }

  save() {
    this.dialogRef.close({ polarities: this.sentimentFilterPolarities });
  }
}
